import { ChangeEventHandler, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, FormLabel, InformationCircleSolid, rem, Text, Textarea, Tooltip } from '@bonusly/design-system';

import { useBookmark } from '../../context';

export const BookmarkEditNotes: FC = () => {
	const { t } = useTranslation('bookmarks');
	const { notes, setNotes } = useBookmark();

	const handleInputChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
		setNotes(() => event.target.value);
	};

	return (
		<Box>
			<FormLabel fontSize="sm" mb={rem(10)}>
				<Flex justifyContent="space-between" alignItems="center">
					<Flex alignItems="center">
						<Text fontWeight="medium" mr={rem(6)}>
							{t('bookmark_modal.add_bookmark_notes_label') ?? ''}
						</Text>
						<Tooltip label={t('bookmark_modal.notes_info_tooltio')} placement="top">
							<Flex alignItems="center" cursor="pointer">
								<InformationCircleSolid size="sm" color="info.icon" />
							</Flex>
						</Tooltip>
					</Flex>
					<Text color="text.softest">{t('bookmark_modal.optional') ?? ''}</Text>
				</Flex>
			</FormLabel>
			<Textarea
				_placeholder={{ color: 'text.softest' }}
				placeholder={t('bookmark_modal.add_notes_placeholder') ?? ''}
				aria-label={t('bookmark_modal.add_notes_placeholder') ?? ''}
				data-testid="note-input"
				onChange={handleInputChange}
				value={notes ?? ''}
				autoFocus
				p={3}
			/>
		</Box>
	);
};
